import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  FormControl,
  TextField,
} from "@mui/material";
import { ToastManager } from "../common/ToastContainer";
import { SESSION_AUTH } from "../../helpers/auth";
import { useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../services";
import FullPageProgress from "../common/FullPageProgress";

export default function CreateOrgModal(props) {
  const { userId } = useParams();
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const { onClose, open, onUpdate } = props;
  const [loader, setLoader] = useState(false);
  const [orgName, setOrgName] = useState("");
  const handleClose = () => {
    onClose();
  };

  const createNewOrg = () => {
    if (!orgName.trim()) {
      return ToastManager.addToast("Enter Organization name");
    }
    setLoader(true);
    EVENTS_SERVICES.createNewOrgazination({
      userId: userSession.userId,
      orgName: orgName.trim(),
      orgOwnerId: userId,
    })
      .then((data) => {
        if (data.code === 200) {
          ToastManager.addToast(data?.message);
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-dialog custom-dialog-full"
    >
      {loader && <FullPageProgress />}
      <DialogTitle className="text-center">Create New Organization</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ marginTop: 2, marginBottom: 5 }}>
            <FormControl fullWidth>
              <TextField
                type="text"
                xs={12}
                label="Name"
                name="name"
                placeholder="Enter organization name"
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
              />
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className="custom-dialog-action">
        <button
          type="button"
          onClick={handleClose}
          className="custom-dialog-btn  managepro6ix-btn managepro6ix-btn-secondary"
        >
          Canel
        </button>

        <button
          type="button"
          onClick={createNewOrg}
          className="custom-dialog-btn  managepro6ix-btn managepro6ix-btn-primary"
        >
          Save
        </button>
      </DialogActions>
    </Dialog>
  );
}
